import { FC, PropsWithChildren } from 'react';
import { Box, Flex, FlexProps } from '@chakra-ui/react';

import { simpleLayoutContentContainerMaxWidth } from '~/core/shared/constants';
import { responsiveValue as rv } from '~/core/shared/utils/general';
import { MiddleOfficeLogo } from './MiddleOfficeLogo';

type SimpleLayoutProps = PropsWithChildren<{
  contentContainerJustifyContent?: FlexProps['justify'];
}>;

export const SimpleLayout: FC<SimpleLayoutProps> = ({
  children,
  contentContainerJustifyContent = 'flex-start',
}) => (
  <Flex
    layerStyle="simpleLayout"
    minH="100vh"
    overflowX="hidden"
    position="relative"
    w="full"
  >
    <Flex direction="column" flex={1}>
      <Box p={rv([5, 8])} w="full">
        <Flex
          alignItems="center"
          color="white"
          justifyContent="space-between"
          layerStyle="simpleLayoutHeader"
        >
          <MiddleOfficeLogo variant="dark" />
        </Flex>
      </Box>

      <Flex
        alignItems="center"
        backgroundPosition="center"
        bgRepeat="no-repeat"
        bgSize="800px 800px"
        direction="column"
        flex={1}
        justifyContent={contentContainerJustifyContent}
        maxW={simpleLayoutContentContainerMaxWidth}
        mx="auto"
        pb={rv([0, 14])}
        position="relative"
        pt={rv([5, 14])}
        px={rv([5, 8])}
        w="full"
      >
        {children}
      </Flex>
    </Flex>
  </Flex>
);
